import { ContentfulTheme } from '@jbhi-fi/apis/src/contentful/types';
import { DeepPartial } from '@jbhi-fi/utils/src/DeepPartial';
import { IconName } from '@jbhi-fi/lanyard-ui/components/Icon';

export type ContentThemePalette = {
  background?: string;
  text?: string;
  heading?: string;
};

export type ContentTheme = {
  palette: ContentThemePalette;
  icon?: IconName;
};

export abstract class ThemeTransformer {
  static stringToColorValue = (str: string): string => {
    if (str?.match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i)) {
      return `#${str.replace(/#/g, '').toUpperCase()}`;
    }
    return str;
  };

  static toContentThemePalette = (entry?: ContentfulTheme): DeepPartial<ContentThemePalette> => {
    return entry?.fields
      ? {
          background: entry.fields.backgroundColourHex
            ? this.stringToColorValue(entry.fields.backgroundColourHex)
            : undefined,
          text: entry.fields.textColourHex ? this.stringToColorValue(entry?.fields?.textColourHex) : undefined,
          heading: entry.fields.headingColourHex ? this.stringToColorValue(entry.fields.headingColourHex) : undefined,
        }
      : {};
  };
  static toContentThemeVariables = (entry?: ContentfulTheme): DeepPartial<ContentTheme> => {
    return entry?.fields
      ? {
          palette: this.toContentThemePalette(entry),
          icon: entry?.fields?.icon?.fields?.name as IconName,
        }
      : { palette: {} };
  };
}
